import React from 'react';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';

/**
 * Represents a higher-order component that allows interaction
 * with the newer functionality of react-router-dom in classes.
 * @param {Object} Component The component.
 */
const withRouter = (Component) => {
  const closure = (props) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
      <Component
        location={location}
        navigate={navigate}
        {...props} />
    );
  };

  return closure;
};

export default withRouter;
